import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {
  Attivazione,
} from './../../../models/attivazione';
import { AlgAttivazioniService } from './../../../services/alg-attivazioni.service';
import { takeUntil} from 'rxjs/operators';
import { Subject } from 'rxjs';


@Component({
  selector: 'alg-attivazioni-linear',
  templateUrl: './alg-attivazioni-linear.component.html',
  styleUrls: ['./alg-attivazioni-linear.component.scss']
})
export class AlgAttivazioniLinearComponent implements OnInit {
  public attivazione: Attivazione;
  public checkboxGasContainer = {
    checkboxGasDeclare: false,
    checkboxGasInformative: false,
  };
  public checkboxLightContainer = {
    checkboxLightDeclare: false,
    checkboxLightInformative: false,
  };
  private ngUnsubscribe = new Subject<void>();
  public opportunityId: string;
  public linearGas : boolean;
  public linearLuce: boolean;

  @Output() optionGasValue = new EventEmitter<boolean>();
  @Output() optionLightValue = new EventEmitter<boolean>();

  constructor(
    private api: AlgAttivazioniService,

  ) { }

  ngOnInit() {
    this.api.attivazione$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((attivazione) => {
        if (!attivazione) {
          return;
        }
        this.attivazione = attivazione;
        this.opportunityId = !!attivazione && attivazione.opportunityId;
      });
    if(this.attivazione.linearGas === true) {
      this.linearGas=true;
    };
    if(this.attivazione.linearLuce===true) {
      this.linearLuce=true;
    };
  }

  getOptionChoices(event, type) {
    switch (type) {
      case 'gas':
        //this.optionGasValue = event;
        this.optionGasValue.emit(event);
        break;

      case 'light':
        // this.optionLightValue = event;
        this.optionLightValue.emit(event);

        break;
    };
  };

  getValidCheckboxes(value, type) {
    switch (type) {
      case 'gas':
        if (value === 'declare') {
          this.checkboxGasContainer.checkboxGasDeclare = false;
        };
        if (value === 'informative') {
          this.checkboxGasContainer.checkboxGasInformative = false;
        };
        break;

      case 'light':
        if (value === 'declare') {
          this.checkboxLightContainer.checkboxLightDeclare = false;
        };
        if (value === 'informative') {
          this.checkboxLightContainer.checkboxLightInformative = false;
        };
    };
  };
};



// WEBPACK FOOTER //
// ./src/app/components/alg-attivazioni/alg-attivazioni-linear/alg-attivazioni-linear.component.ts